<template>
  <div id="createCollector">
    <div class="o-modal">
      <div class="o-modal-content">
        <div class="o-modal-header">
          <a
            @click="closeCreateCollectorModal()"
            class="close clickable"
          ><i class="far fa-times"></i></a>
          <p class="lead" v-if="!$store.state.display.editMode">Create Data Collector</p>
          <p class="lead" v-if="$store.state.display.editMode">Edit Data Collector</p>
        </div><!-- /.o-modal-header -->
        <div class="o-modal-body pt-2">
          <!-- IMPORT/EXPORT TEMPLATE -->
          <div class="mb-2 text-right">
            <b-btn
              v-if="!$store.state.display.editMode"
              size="sm"
              class="mr-1"
              @click="importMode = true"
            ><i class="fas fa-file-import"></i> Import Settings</b-btn>
            <b-btn
              v-if="collector.name"
              size="sm"
              @click="exportSettings()"
            ><i class="fas fa-file-export"></i> Export Settings</b-btn>
            <div
              v-if="importMode"
              class="bg-white p-1 mt-2 card"
            >
              <i @click="importMode = false" class="fas fa-times-circle clickable" style="position:absolute;top:5px;right:5px;"></i>
              <label class="text-left">Upload Import File:</label>
              <input
                type="file"
                class="form-control-file"
                accept=".txt"
                @change="onImportSelected"
                id="importFileInput"
              />
            </div><!-- if import mode -->
          </div><!-- /.text-right -->
          <!-- END TEMPLATE IMPORT/EXPORT -->
          <form @submit.prevent>

            <!-- NAME -->
            <div class="form-group">
              <label>What data are you collecting? (eg. Broken Posts)</label>
              <input
                v-model="collector.name"
                class="form-control"
              />
            </div><!-- /.form-group -->

            <!-- DESCTIPTION -->
            <div class="form-group">
              <label>Provide a description of this data type</label>
              <textarea
                v-model="collector.description"
                class="form-control"
              />
            </div><!-- /.form-group -->

            <!-- GEOMETRY TYPE -->
            <div class="form-group">
              <label>Location type</label>
              <div>
                <b-form-radio-group v-model="geometryTypeModel" buttons>
                  <b-form-radio value="point" active-variant="success">Point</b-form-radio>
                  <b-form-radio value="line" active-variant="success">Line</b-form-radio>
                  <b-form-radio value="polygon" active-variant="success">Polygon</b-form-radio>
                </b-form-radio-group>
              </div>
              <small class="text-muted">Point: tap or use GPS to capture one location per record. Line: draw a path per record. Polygon: draw an area per record.</small>
            </div><!-- /.form-group -->

            <div class="form-group">
              <label>Headers</label>
              <div class="list-group" v-if="!hideHeaders">
                <draggable
                  v-model="collector.fields"
                  :disabled="draggableDisabled"
                  @update="sortByGroup"
                >
                  <div
                    v-for="(field, i) in collector.fields"
                    v-bind:key="i"
                    class="list-group-item list-group-item-action"
                    :class="{ disabled: field.type === 'CV Number'}"
                  >
                  <p class="mb-0" v-if="field.group">
                    <b-badge
                      pill
                      class="mr-1"
                      variant="primary"
                    >{{ field.group }}</b-badge>
                  </p>
                    <p class="lead mb-1">
                      <i v-if="field.type == 'CV Number'" class="fas fa-lock mr-1"></i>
                      <i v-if="field.type == 'Text'" class="fas fa-text"></i>
                      <i v-if="field.type == 'Computer Vision'" class="fas fa-robot"></i>
                      <i v-if="field.type == 'Number' || field.type == 'CV Number'" class="fas fa-hashtag"></i>
                      <i v-if="field.type == 'Select'" class="far fa-ballot-check"></i>
                      <i v-if="field.type == 'Date and Time'" class="far fa-clock"></i>
                      <i v-if="field.type == 'Image'" class="fas fa-image"></i>
                      &nbsp;{{ field.label }}
                      <span v-if="field.type == 'CV Number'"><br><small>*Controlled by CV Header</small></span>
                    </p>
                    <b-btn
                      size="sm"
                      variant="success"
                      @click="editField(i)"
                      class="mr-1"
                      v-if="!field.hidden && field.type !== 'CV Number'"
                    ><i class="fas fa-pencil clickable"></i> Edit</b-btn>
                    <b-btn
                      size="sm"
                      variant="success"
                      class="mr-1 disabled"
                      v-if="field.hidden && field.type !== 'CV Number'"
                    ><i class="fas fa-pencil clickable"></i> Edit</b-btn>
                    <b-btn
                      size="sm"
                      variant="warning"
                      @click="duplicate(field, i)"
                      class="mr-1"
                      v-if="!field.hidden && field.type !== 'Image' && field.type !== 'Computer Vision' && field.type !== 'CV Number'"
                    ><i class="far fa-clone clickable"></i> Duplicate</b-btn>
                    <b-btn
                      size="sm"
                      variant="warning"
                      class="mr-1 disabled"
                      v-if="field.hidden && field.type !== 'Image' && field.type !== 'Computer Vision'"
                    ><i class="far fa-clone clickable"></i> Duplicate</b-btn>
                    <b-btn
                      size="sm"
                      class="mr-1"
                      @click="hideHeader(i)"
                      v-if="!field.hidden && field.type !== 'CV Number'"
                    ><i class="fas fa-eye-slash"></i> Hide</b-btn>
                    <b-btn
                      size="sm"
                      class="mr-1"
                      @click="unhideHeader(i)"
                      v-if="field.hidden && field.type !== 'CV Number'"
                      variant="success"
                    ><i class="fas fa-eye-slash"></i> Unhide</b-btn>
                    <b-btn
                      size="sm"
                      variant="danger"
                      @click="removeHeader(i)"
                      v-if="!field.hidden && field.type !== 'CV Number'"
                    ><i class="fas fa-minus-circle"></i> Remove</b-btn>
                    <b-btn
                      size="sm"
                      variant="danger"
                      class="disabled"
                      v-if="field.hidden && field.type !== 'CV Number'"
                    ><i class="fas fa-minus-circle"></i> Remove</b-btn>
                  </div>
                </draggable>
              </div><!-- list-group -->
              <b-btn
                @click="addField()"
                class="mt-2"
              ><i class="far fa-plus"></i> Add a Header</b-btn>
            </div><!-- /.form-group -->

            <div id="collectorEditors">
              <p class="mb-1"><strong>Collector Permissions</strong><br><small>Grant access to use this collector.</small></p>
              <b-form-checkbox-group
                v-model="collectorEditors"
                :options="editorOptions"
                class="mb-3"
                value-field="id"
                text-field="email"
                @change="updateEditors"
              ></b-form-checkbox-group>
            </div><!-- /#collectorEditors -->
          </form>
        </div><!-- /.o-modal-body -->
        <div class="o-modal-footer">
          <div class="drawer-footer">
            <button
              v-if="!saving"
              @click="saveCollector()"
              class="btn btn-primary mr-1 w-50"
            >
              Save
            </button>
            <button
              v-if="saving"
              class="btn btn-secondary mr-1 w-50"
            >
            <i class="fad fa-spinner-third fa-spin"></i> Saving...
            </button>
            <button
              v-if="$store.state.display.editMode"
              @click="confirmDelete = true"
              class="btn btn-danger"
            >
              Delete
            </button>
          </div><!-- /.float-right -->
        </div><!-- /.o-modal-footer -->
      </div><!-- /.o-modal-content -->
    </div><!-- /. o-modal -->

    <!-- ADD FIELD MODAL -->
    <AddField :editMode="editMode" :fieldIndex="fieldIndex" v-if="$store.state.display.modal.addField === true" />

    <Confirm
      v-if="confirmDelete"
      text="DANGER! Are you sure you want to delete this collector? This cannot be undone! NOTE: The dataset associated with this data collector will also be deleted. Consider backing that up first!"
      v-on:confirmed="deleteCollector($event)"
    />
    <Confirm
      v-if="removeHeaderConfirm"
      text="DANGER! Are you sure you want to remove this header?"
      v-on:confirmed="removeHeaderForReal($event)"
    />
  </div><!-- /#createCollector -->
</template>

<script>
import AddField from './AddField'
import Confirm from '../Confirm'
import draggable from 'vuedraggable'
const fb = require('../../firebaseConfig.js')

export default {
  data () {
    return {
      confirmDelete: false,
      editMode: false,
      fieldIndex: false,
      importMode: false,
      draggableDisabled: false,
      collectorEditors: [],
      editorOptions: [],
      hideHeaders: false,
      headerToRemove: false,
      removeHeaderConfirm: false,
      saving: false
    }
  },
  components: {
    AddField,
    Confirm,
    draggable
  },
  computed: {
    collector: {
      get () {
        return this.$store.state.collector
      },
      set (value) {
        this.$store.commit('setCollector', value)
      }
    },
    geometryTypeModel: {
      get () {
        return (this.collector && this.collector.geometryType) ? this.collector.geometryType : 'point'
      },
      set (val) {
        if (!this.collector) return
        this.$store.commit('setCollector', { ...this.collector, geometryType: val })
      }
    }
  },
  created () {
    this.gatherEditorOptions()
    // DISABLE DRAGGABLE ON MOBILE
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    if (vw < 800) {
      this.draggableDisabled = true
    }
  },
  mounted () {
    this.sortByGroup()
  },
  methods: {
    duplicate (field, i) {
      const fieldObj = JSON.parse(JSON.stringify(field))
      fieldObj.machine_name = fieldObj.machine_name + '_copy'
      if (fieldObj.machine_name === 'dataPointId') {
        fieldObj.machine_name = 'dataPointId_field'
      }
      fieldObj.label = fieldObj.label + ' COPY'
      this.collector.fields.splice(i + 1, 0, fieldObj)
      this.ensureNoDataPointIdMachineName()
      console.log(fieldObj)
    },
    sortByGroup () {
      // Create two arrays, one for fields with a group and one for fields without a group
      const withGroup = []
      const withoutGroup = []

      // Populate the two arrays
      this.collector.fields.forEach((field, index) => {
        // Add a property 'index' to maintain the original order
        field.index = index
        if (field.group) {
          withGroup.push(field)
        } else {
          withoutGroup.push(field)
        }
      })

      // Sort the 'withGroup' array by the 'group' property
      withGroup.sort((a, b) => {
        if (a.group < b.group) return -1
        if (a.group > b.group) return 1
        return a.index - b.index // In case of equal groups, maintain original order
      })

      // The final sorted array is the concatenation of 'withoutGroup' and 'withGroup'
      this.collector.fields = withoutGroup.concat(withGroup)

      // Remove the 'index' property as it's no longer needed
      this.collector.fields.forEach(field => {
        delete field.index
      })
    },
    removeHeaderForReal (confirmed) {
      const headerToRemoveData = JSON.parse(JSON.stringify(this.collector.fields[this.headerToRemove]))
      console.log(headerToRemoveData)
      this.removeHeaderConfirm = false
      if (confirmed) {
        this.collector.fields.splice(this.headerToRemove, 1)
        // If computer vision, remove all CV fields
        // if (headerToRemoveData.type === 'Computer Vision') {
        //   for (let i = this.collector.fields.length - 1; i >= 0; i--) {
        //     if (this.collector.fields[i].type === 'CV Number') {
        //       this.collector.fields.splice(i, 1)
        //     }
        //   }
        // }
      }
    },
    removeHeader (index) {
      this.headerToRemove = index
      this.removeHeaderConfirm = true
    },
    unhideHeader (headerIndex) {
      this.hideHeaders = true
      this.collector.fields[headerIndex].hidden = false
      this.hideHeaders = false
    },
    hideHeader (headerIndex) {
      this.hideHeaders = true
      this.collector.fields[headerIndex].hidden = true
      this.hideHeaders = false
    },
    updateEditors (e) {
      this.collectorEditors = e
      console.log(this.collectorEditors)
    },
    gatherEditorOptions () {
      this.collectorEditors = this.collector.editors || []
      this.$store.state.farm.collaboratorData.forEach(collaborator => {
        const collaboratorId = collaborator.id
        const permissionLevel = this.$store.state.farm.permissions[collaboratorId]
        if (permissionLevel === 'Permission-only' || permissionLevel === 'Read-only') {
          this.editorOptions.push(collaborator)
        }
      })
    },
    onImportSelected (e) {
      const reader = new FileReader()
      reader.readAsText(e.target.files[0])
      reader.onload = e => {
        console.log(e.target.result)
        const fileContentsData = JSON.parse(e.target.result)
        console.log(fileContentsData)
        this.collector.description = fileContentsData.description
        this.collector.fields = fileContentsData.fields
        this.collector.name = fileContentsData.name
        this.collector.geometryType = fileContentsData.geometryType || 'point'
        this.importMode = false
        this.ensureNoDataPointIdMachineName()
      }
    },
    exportSettings () {
      console.log(this.collector)
      const settingsContent = {
        description: this.collector.description,
        fields: this.collector.fields,
        name: this.collector.name,
        geometryType: this.geometryTypeModel
      }
      function camelize (str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
          return index === 0 ? word.toLowerCase() : word.toUpperCase()
        }).replace(/\s+/g, '')
      }
      const fileName = camelize(this.collector.name)
      const fileData = JSON.stringify(settingsContent)
      // Get the file contents
      const fileFullName = fileName + '_collector_template.txt'
      function downloadFile (content, fileName) {
        var a = document.createElement('a')
        var file = new Blob([content], { type: 'text/plain' })
        a.href = URL.createObjectURL(file)
        a.download = fileName
        a.click()
      }
      downloadFile(fileData, fileFullName)
    },
    deleteCollector (confirmed) {
      if (confirmed) {
        this.confirmDelete = false
        fb.collectorsCollection.doc(this.collector.id).delete().then(() => {
          this.$store.commit('setEditMode', false)
          this.$store.dispatch('initFarmMap')
          // this.$store.commit('resetDrawers')
          this.$store.dispatch('fetchCollectors', this.$store.state.farm.id)
          this.$store.commit('toggleModal', 'createCollector')
          this.$store.commit('setAlert', { active: true, message: 'Data collector successfully deleted.', level: 'alert-info', timeout: 3000 })
          fb.datasetsCollection.doc(this.collector.datasetId).delete()
        }).catch(err => { console.log(err) })
      } else {
        this.confirmDelete = false
        return false
      }
    },
    saveCollector () {
      this.ensureNoDataPointIdMachineName()
      this.saving = true
      this.sortByGroup()
      if (!this.collector.name) {
        alert('You must name this data collector!')
        return false
      }
      if (this.$store.state.display.editMode === true) {
        console.log(this.collector)
        fb.collectorsCollection.doc(this.collector.id).update({
          updatedBy: this.$store.state.currentUser.uid,
          updatedOn: new Date(),
          name: this.collector.name,
          description: this.collector.description || '',
          fields: this.collector.fields,
          editors: this.collectorEditors,
          geometryType: this.geometryTypeModel,
          reCompile: true
        }).then(collectorDoc => {
          const datasetHeaders = []
          this.collector.fields.forEach(field => {
            datasetHeaders.push(field.label)
          })
          // Update the dataset to keep in sync
          return fb.datasetsCollection.doc(this.collector.datasetId).update({
            dynamic: true,
            name: this.collector.name || '',
            description: this.collector.description || '',
            headers: datasetHeaders || []
          })
        }).then(() => {
          this.$store.dispatch('turnOffCollectorClick')
          this.$store.commit('setEditMode', false)
          this.$store.dispatch('fetchCollectors', this.$store.state.farm.id)
          this.$store.commit('toggleModal', 'createCollector')
        }).catch(err => {
          console.log(err)
          this.saving = false
        })
      } else {
        fb.collectorsCollection.add({
          createdOn: new Date(),
          updatedOn: new Date(),
          createdBy: this.$store.state.currentUser.uid,
          updatedBy: this.$store.state.currentUser.uid,
          ownerId: this.$store.state.currentUser.uid,
          name: this.collector.name,
          description: this.collector.description || '',
          editors: this.collectorEditors,
          fields: this.collector.fields,
          geometryType: this.geometryTypeModel,
          farmId: this.$store.state.farm.id,
          trashed: false
        }).then(collectorDoc => {
          this.collector.id = collectorDoc.id
          const datasetHeaders = []
          this.collector.fields.forEach(field => {
            datasetHeaders.push(field.label)
          })
          // Create dynamic dataset
          return fb.datasetsCollection.add({
            dynamic: true,
            collectorId: collectorDoc.id,
            createdOn: new Date(),
            updatedOn: new Date(),
            createdBy: this.$store.state.currentUser.uid,
            name: this.collector.name || '',
            description: this.collector.description || '',
            headers: datasetHeaders || [],
            farmId: this.$store.state.farm.id,
            file: {},
            folderId: 'root'
          })
        }).then(datasetDoc => {
          fb.compileRequestsCollection.add({
            createdBy: this.$store.state.currentUser.uid,
            createdOn: new Date(),
            collectorId: this.collector.id,
            datasetId: datasetDoc.id,
            lastUpdated: new Date(),
            farmId: this.$store.state.farm.id
          })
          return fb.collectorsCollection.doc(this.collector.id).update({
            datasetId: datasetDoc.id
          })
        }).then(() => {
          this.$store.dispatch('turnOffCollectorClick')
          this.$store.commit('setEditMode', false)
          this.$store.dispatch('fetchCollectors', this.$store.state.farm.id)
          this.$store.commit('toggleModal', 'createCollector')
        }).catch(err => {
          console.log(err)
          this.saving = false
        })
      }
    },
    addField () {
      this.editMode = false
      this.fieldToEdit = false
      this.$store.commit('toggleModal', 'addField')
      // After the modal closes and a field is added, ensure no forbidden machine_name
      // This may need to be called after the field is actually added, so also call in a watcher or after modal closes if needed
      setTimeout(() => { this.ensureNoDataPointIdMachineName() }, 500)
    },
    editField (i) {
      this.editMode = true
      this.fieldIndex = i
      this.$store.commit('toggleModal', 'addField')
    },
    closeCreateCollectorModal () {
      this.$store.commit('toggleModal', 'createCollector')
    },
    ensureNoDataPointIdMachineName () {
      // Utility to ensure no field has machine_name 'dataPointId'
      this.collector.fields.forEach(field => {
        if (field.machine_name === 'dataPointId' || field.machine_name === 'datapointid') {
          field.machine_name = 'dataPointId_field'
        }
      })
    }
  }
}
</script>
